<template>
	<div class="buscases-subview">
		<div class="subviewOpts">
			<span class="button-link-group">
				<label for="busCaseTypeSelect"><sym-icon name="case"></sym-icon> {{ env.msg('menu.addBusCase') }}:</label>
				<select id="busCaseTypeSelect" v-model.number="caseType" @change="createByType">
					<option value="0">-</option>
					<option v-for="bct of ns.busCaseTypes" :key="bct.id" :value="bct.id">{{ bct.localizedName }}</option>
				</select>
			</span>
		</div>
		<div id="buscasesSubview">
			<crm-table :rest-api="restApi"></crm-table>
		</div>

	</div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";
import {injectEnv} from "@fd/Environment.ts";
import {addContextParams, BUSCASE_REFS, ContextKey, getIntValue, injectContext, OPPORTUNITY_REFS} from "@t/fd/AppContext.ts";
import SymIcon from "@fd/helpers/SymIcon.vue";
import {useNavigationStore} from "@/store/NavigationStore.ts";
import CrmTable from "@/vue/table/CrmTable.vue";
import {go} from "@/router/Router.ts";

const env = injectEnv();
const ctx = injectContext();
const ns = useNavigationStore();
const sourceType = computed<number>(() => getIntValue(ctx.value, ContextKey.SRC_TYPE));
const sourceId = computed<string|number>(() => getIntValue(ctx.value, ContextKey.SRC_ID));

const caseType = ref<number>(0);

const restApi = computed<string>(() => {
	let ep = "api/buscases/agendaSubview";
	ep = env.net.urlParam(ep, "srcType", sourceType.value);
	ep = env.net.urlParam(ep, "srcId", sourceId.value);
	return ep;
});

const createOpportunityLink = computed<string>(() => {
	let link = addContextParams('createOpportunity.do', ctx.value, OPPORTUNITY_REFS);
	return link;
});

function createByType() {
	if (caseType.value) {
		let link = addContextParams('createBusCase.do', ctx.value, BUSCASE_REFS);
		link = env.net.urlParam(link, "bctype", caseType.value);
		go(link);
	}
}
</script>

<style>

</style>